<template>
  <div id="fillPaticipantInfo" class="safe-distance-top">
    <div class="sign-up-content">
      <!-- 顶部显示所选择的规格信息 -->
      <div class="meeting-top section-default">
        <img :src="skuData.pictureUrl" alt="" />
        <div class="meeting-info">
          <h1>{{ skuData.meetingTitle }}</h1>
          <p style="overflow: hidden; text-overflow: ellipsis">
            <span style="white-space: nowrap">{{ skuData.selectedText }}</span>
            <span v-if="skuData.isExamine">【需要审核】</span>
          </p>
          <p>库存：{{ skuData.stock_num }}</p>
          <div class="price-count">
            <h2 class="price">
              <span class="symbol">￥</span>
              <span>{{ skuData.price }}</span>
            </h2>
            <van-stepper
              v-model="skuData.selectedNum"
              min="1"
              :max="skuData.stock_num"
              disable-input
              @change="changeCount"
            />
          </div>
        </div>
      </div>
      <!-- 报名人表单列表 -->
      <van-form
        :label-width="80"
        :scroll-to-error="true"
        @submit="submitMemberInfo"
      >
        <!-- 投稿期刊/采编 -->
        <div
          class="section-default"
          v-if="isSubmitThesis && periodicalList.length"
        >
          <van-field
            v-model="periodical"
            label="拟投稿期刊"
            is-link
            readonly
            placeholder="请选择"
            :required="true"
            :rules="[
              {
                required: true,
                message: '请选择',
                trigger: 'onBlur',
              },
            ]"
            @click="periodicalPick = true"
          />
          <van-field
            v-model="inviter"
            label="会议邀约人"
            is-link
            readonly
            placeholder="请选择"
            :required="isInviterMust"
            :rules="[
              {
                required: isInviterMust,
                message: '请选择',
                trigger: 'onBlur',
              },
            ]"
            @input="inviter = ''"
            @click="inviterPick = true"
          />
        </div>
        <div
          class="sign-form section-default"
          v-for="(meetingItem, meetingKey) in meetingMemberList"
          :key="meetingItem.id"
        >
          <div class="sign-form-title">
            <h1>参会人{{ meetingKey + 1 }}</h1>
            <van-icon name="delete-o" @click="toDelete(meetingKey)" />
          </div>
          <!-- 配置对象 -->
          <div>
            <SignForm
              v-if="signFormFormat.length"
              :isPay="isPay"
              :isCheckPhone="isCheckPhone"
              :meetingMemberList="meetingMemberList"
              :meetingItem="meetingItem"
              :meetingKey="meetingKey"
              :signFormFormat="signFormFormat"
              :birthdayOptions="birthdayOptions"
              :titleOptions="titleOptions"
              :subjectOptions="subjectOptions"
              :areaOptions="areaOptions"
              :educationOptions="educationOptions"
              @formChange="(value) => signFormChange(meetingKey, value)"
            />
          </div>
        </div>
        <!-- @click="submitMemberInfo" -->
        <div class="submit-area" style="padding: 16px; background: #fff">
          <van-button round block type="info" native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
      <!-- 投稿期刊 picker -->
      <van-action-sheet
        v-model="periodicalPick"
        title="拟投稿期刊"
        :actions="periodicalList"
        @select="periodicalSelect"
      />
      <!-- 邀约人 picker -->
      <van-action-sheet v-model="inviterPick" title="会议邀约人">
        <div class="sheet-content">
          <van-search
            v-model.trim="searchInviter"
            placeholder="搜索邀约人"
            left-icon=""
            @search="inviterToSearch"
          >
            <template #right-icon>
              <van-icon name="search" @click="inviterToSearch(searchInviter)" />
            </template>
          </van-search>
          <ul class="sheet-list">
            <li
              class="sheet-list-item"
              v-for="item in inviterList"
              :key="item.id"
              @click="inviterSelect(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </van-action-sheet>
    </div>
  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
import SignForm from "./components/signForm";
// import { validateRules } from "./memberInfoValidate.js";

export default {
  name: "fillPaticipantInfo",
  components: { SignForm },
  data() {
    return {
      skuData: {
        goodsId: "",
        pictureUrl: "",
        meetingTitle: "",
        meetingId: "",
        selectedNum: 1,
        selectedText: "",
        price: "",
        stock_num: null,
        // 是否需要审核
        isExamine: null,
        // 是否app访问
        fromApp: false,
      },
      isPay: false,
      // -------- 会议投稿/邀约人参数 ----------
      isSubmitThesis: false, // 是否需要投稿期刊
      isInviterMust: false, // 是否需要会议邀约人
      periodicalList: [],
      periodicalPick: false,
      baseInviterList: [{ id: "-1", name: "无邀约人" }],
      inviterList: [],
      inviterPick: false,
      searchInviter: "",
      periodical: "",
      periodicalId: "",
      inviter: "",
      inviterId: "",
      // ------- 会议报名表单参数 --------
      isCheckPhone: false, // 是否要校验手机号
      signUp: [],
      // 会议报名人信息对象
      meetingMemberInfo: {
        id: "",
        name: "",
        phone: "",
        headPhoto: [],
        sex: "",
        birthday: "",
        school: "",
        inStudy: 0,
        nation: "",
        eduVal: "",
        education: "",
        researchDirections: "",
        subjects: [
          {
            levelOne: "",
            levelTwo: "",
            fieldValue: "",
          },
        ],
        titles: [
          {
            // 职级
            levelOne: "",
            // 自定义职称
            levelTwo: "",
            // 前端回显职级数据 levelOneName
            levelOneName: "",
          },
        ],
        org: {
          name: "",
          job: "",
          address: "",
          postalCode: "",
          country: 0,
          province: "",
          provinceCode: "",
          city: "",
          cityCode: "",
        },
        idCard: "",
        mailbox: "",
        remark: "",
      },
      meetingMemberList: [], // 会议报名人列表
      signFormFormat: [], // 报名表单项列表
      areaOptions: [], // 省份选择项
      birthdayOptions: [], // 年份选择项
      titleOptions: [], // 职级选择项
      subjectOptions: [], // 学科领域选择项
      educationOptions: [], // 学历学位
    };
  },
  created() {
    document.title = "报名信息";
    if (
      sessionStorage.getItem("skuData") &&
      sessionStorage.getItem("userInfo")
    ) {
      // 获取SKU数据
      this.skuData = JSON.parse(sessionStorage.getItem("skuData"));
      // 获取会议详情
      this.getMeetingDetail();
      // 获取报名表单
      this.formatFormConfig();
    } else {
      // 信息失效返回上一页
      this.$toast.fail("报名信息已失效，请重新选择");
      setTimeout(this.$router.go(-1), 2200);
    }
  },
  methods: {
    // 获取一个随机id
    generateRandomId() {
      // 获取当前时间戳
      const timestamp = Date.now();
      // 生成随机数并将其转换为36进制字符串
      const randomPart = Math.random().toString(36).substr(2, 9);
      // 组合时间戳和随机数生成ID
      const randomId = timestamp.toString(36) + "-" + randomPart;

      // 返回生成的ID
      return randomId;
    },
    // 获取会议详情
    async getMeetingDetail() {
      const { resultCode, data } =
        await this.$apis.goodsServe.meetingDetailsByGoodsId({
          goodsId: this.skuData.goodsId,
          frontEnd: 1,
        });
      if (resultCode === "200") {
        this.isPay = data.pay;
        let selectGood = data.goodsDto.goodsSkuInfosDto.list.filter(
          (item) => item.id === this.skuData.skuId
        );
        this.isSubmitThesis =
          data.articleMeeting.isSubmit && selectGood[0].isSubmitThesis === 1;
        if (this.isSubmitThesis) this.getPeriodicals();
        this.isInviterMust = data.articleMeeting.isInviterMust || false;
        this.isCheckPhone = data.articleMeeting.isCheckPhone || false;
        this.getFormListInfo();
      } else {
        // 信息失效返回上一页
        this.$toast.fail("报名信息已失效，请重新选择");
        setTimeout(this.$router.go(-1), 2200);
      }
    },
    // 自动填充表单信息两个方式 => 已经填过到订单确认回显/该账号学者信息自动回显
    getFormListInfo() {
      if (sessionStorage.getItem("periodicalForm")) {
        let periodicalForm = JSON.parse(
          sessionStorage.getItem("periodicalForm")
        );
        for (const key in periodicalForm) {
          this[key] = periodicalForm[key];
        }
      }
      if (sessionStorage.getItem("meetingMemberList")) {
        this.meetingMemberList = JSON.parse(
          sessionStorage.getItem("meetingMemberList")
        );
      } else {
        // 没有提交过表单初始化回显
        this.initializeFormList();
      }
    },
    // 初始化报名表单数据
    async initializeFormList() {
      const obj = this.$global.deepClone(this.meetingMemberInfo);
      if (!this.isPay) {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        obj.phone = userInfo.account;
        if (userInfo.user.customerType === 2) {
          obj.name = userInfo.name;
          const {
            messageType,
            resultCode,
            data: userData,
          } = await this.$apis.userServe.phoneGetUserinfo(userInfo.account);
          if (resultCode === "200" && messageType === "Success") {
            for (const key in obj) {
              if (key === "headPhoto") {
                if (userData.userInfo.headPhoto) {
                  obj[key] = [
                    {
                      fileUrl: userData.userInfo.headPhoto,
                      content:
                        this.$global.imgUrl + userData.userInfo.headPhoto,
                      url: this.$global.imgUrl + userData.userInfo.headPhoto,
                    },
                  ];
                }
              } else if (key === "mailbox") {
                obj[key] = userData.userInfo.email;
              } else if (key === "birthday") {
                obj[key] = userData.userInfo[key]
                  ? userData.userInfo[key].slice(0, 4)
                  : "";
              } else if (key === "subjects") {
                let subjectsList = userData.subjects;
                if (subjectsList.length) {
                  obj[key] = subjectsList.map((subjectItem) => ({
                    fieldValue: `${subjectItem.levelOneName}/${subjectItem.levelTwoName}`,
                    levelOne: subjectItem.levelOne,
                    levelTwo: subjectItem.levelTwo,
                  }));
                }
              } else if (key === "titles") {
                let titles = userData.titles;
                if (titles.length) {
                  obj[key] = titles.map((titleItem) => ({
                    levelOne: titleItem.levelOne,
                    levelOneName: titleItem.levelOneName,
                    levelTwo: titleItem.levelTwo,
                  }));
                }
              } else if (key === "org") {
                let scholarPresentUnits = userData.scholarPresentUnits.filter(
                  (i) => i.defaultStatus
                );
                if (scholarPresentUnits.length) {
                  obj[key].name = scholarPresentUnits[0].unitName;
                  obj[key].job = scholarPresentUnits[0].job;
                  obj[key].address = scholarPresentUnits[0].address;
                  obj[key].postalCode = scholarPresentUnits[0].postCode;
                  obj[key].country = scholarPresentUnits[0].country;
                  obj[key].province = scholarPresentUnits[0].provinceName;
                  obj[key].provinceCode = scholarPresentUnits[0].province;
                  obj[key].city = scholarPresentUnits[0].cityName;
                  obj[key].cityCode = scholarPresentUnits[0].city;
                }
              } else if (
                key !== "name" &&
                key !== "phone" &&
                userData.userInfo.hasOwnProperty(key)
              ) {
                obj[key] = userData.userInfo[key];
              }
            }
          }
        } else if (userInfo.user.customerType !== 1) {
          obj.name = userInfo.companyName;
        }
        obj.id = this.generateRandomId();
      }
      this.meetingMemberList.push(obj);
    },
    // 商品修改数量增减报名表单数量
    changeCount(value) {
      // 页面表单数量
      var currentLength = this.meetingMemberList.length;
      if (currentLength > value) {
        // 减少报名表单
        this.meetingMemberList = this.meetingMemberList.slice(0, value);
      } else {
        // 增加报名表单
        for (currentLength; currentLength < value; currentLength++) {
          let obj = this.$global.deepClone(this.meetingMemberInfo);
          obj.id = this.generateRandomId();
          this.meetingMemberList.push(obj);
        }
      }
    },
    // 删除报名表单一项
    toDelete(index) {
      if (this.meetingMemberList.length > 1) {
        this.meetingMemberList.splice(index, 1);
        this.skuData.selectedNum = this.skuData.selectedNum - 1;
      }
    },
    // 选择拟投稿期刊
    periodicalSelect(value) {
      this.periodical = value.name;
      this.periodicalId = value.id;
      this.periodicalChange(value.id);
      this.inviter = "";
      this.inviterId = "";
      this.periodicalPick = false;
    },
    // 选择会议邀约人
    inviterSelect(value) {
      this.inviter = value.name;
      this.inviterId = value.id;
      this.inviterPick = false;
    },
    // 获取投稿期刊列表
    async getPeriodicals() {
      const res = await this.$apis.goodsServe.getMeetingPeriodicals(
        this.skuData.meetingId
      );
      if (res.resultCode === "200" && res.data.periodicalList.length) {
        let pList = res.data.periodicalList.filter((item) => item.isSubmit);
        if (pList.length) {
          this.periodicalList = pList.map((item) => ({
            name: item.perName,
            id: item.perId,
          }));
          this.periodicalChange(this.periodicalList[0].id);
          this.periodical = this.periodicalList[0].name;
          this.periodicalId = this.periodicalList[0].id;
        }
      }
    },
    // 获取合作期刊采编(邀约人)
    async periodicalChange(perId) {
      this.baseInviterList = [{ id: "-1", name: "无邀约人" }];
      const res = await this.$apis.goodsServe.queryEditorial({
        perId,
        pageNo: 1,
        pageSize: 9999,
      });
      if (res.resultCode === "200") {
        res.data.list.forEach((item) => {
          if (item.enable === 1) {
            this.baseInviterList.push({
              name: item.name,
              id: item.userId,
            });
          }
        });
        this.inviterList = this.baseInviterList;
      }
    },
    // 邀约人列表筛选
    inviterToSearch(value) {
      this.inviterList = this.baseInviterList.filter((item) =>
        item.name.includes(value)
      );
    },
    signFormChange(key, value) {
      const id = this.meetingMemberList[key].id;
      this.$set(this.meetingMemberList, key, { id, ...value });
    },
    // 格式化表单项配置列表，筛选vanfield类型
    async formatFormConfig() {
      const res = await this.$apis.goodsServe.meetingFormTem(
        this.skuData.goodsId
      );
      if (res.resultCode === "200") {
        this.signUp = res.data;
        this.signFormFormat = res.data.map((item, index) => {
          if (item.code === "birthday") this.initBirthdayActions();
          if (item.code === "subjects") this.getRelationListMethod();
          if (item.code === "titles") this.getTitleListMethod();
          if (item.code === "org") this.getProvinceMethod();
          if (item.code === "education") this.getEducationOptionsList();
          let type = item.code;
          let textList = [
            "name",
            "school",
            "nation",
            "researchDirections",
            "idCard",
            "mailbox",
            "remark",
            "text",
          ];
          if (textList.includes(item.code)) {
            type = "text";
          }
          return {
            type,
            key: item.isCustomize === 1 ? item.configKey : item.code,
            label: item.value,
            required: item.must === 1,
            isMultiple: item.isMultiple === 1,
            placeholder: (item.config && item.config.placeholder) || "",
            options: (item.config && item.config.options) || [],
            format: (item.config && item.config.format) || "",
          };
        });
      } else {
        // 信息失效返回上一页
        this.$toast.fail("报名信息已失效，请重新选择");
        setTimeout(this.$router.go(-1), 2200);
      }
    },
    // 初始化出生年月范围
    initBirthdayActions() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      for (let i = 1900; i < currentYear + 1; i++) {
        this.birthdayOptions.unshift({ name: i + "" });
      }
    },
    // 获取职级列表
    getTitleListMethod() {
      this.$apis.userServe.getTitleList().then((res) => {
        if (res.resultCode == 200) {
          this.titleOptions = res.data.map((item) => {
            return {
              name: item.titleName,
              value: item.titleCode + "",
            };
          });
        } else {
          this.$toast.console.error(res.resultDesc);
        }
      });
    },
    // 获取学科领域列表
    getRelationListMethod() {
      this.$apis.userServe.getRelationList().then((res) => {
        if (res.resultCode == 200) {
          this.subjectOptions = res.data;
        } else {
          this.$toast.console.error(res.resultDesc);
        }
      });
    },
    // 获取学科领域列表
    getProvinceMethod() {
      this.$apis.userServe.proList().then((res) => {
        if (res.resultCode == 200) {
          this.areaOptions = res.content.provinceList.map((item) => ({
            label: item.name,
            value: item.code,
            children: [],
          }));
        } else {
          this.$toast.console.error(res.resultDesc);
        }
      });
    },
    // 获取学历/学位
    async getEducationOptionsList() {
      const { resultCode, data } = await this.$apis.userServe.getEducation();
      if (resultCode === "200") {
        this.educationOptions = data.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.childrens,
          };
        });
      }
    },
    // 提交审核信息
    submitMemberInfo() {
      let signUpData = {
        meetingId: this.skuData.meetingId,
        isExamine: this.skuData.isExamine,
        articleMeetingMemberAudit: {
          number: this.skuData.selectedNum,
        },
      };
      if (this.skuData.promoterId) {
        signUpData.promoterId = this.skuData.promoterId;
      }
      signUpData.meetingMemberList = this.meetingMemberList.map((item) => {
        let obj = {
          skuId: this.skuData.skuId,
          skuName: this.skuData.skuName,
          skuPrice: this.skuData.skuPrice,
          signUp: this.signUp,
          customizeConfig: [],
        };
        if (this.isSubmitThesis && this.periodicalList.length) {
          obj.periodicalId = this.periodicalId;
          obj.inviterId = this.inviterId || "";
        }
        this.signUp.forEach((signItem) => {
          if (signItem.isCustomize === 1) {
            if (
              item[signItem.configKey] !== undefined &&
              item[signItem.configKey] !== "" &&
              item[signItem.configKey].length
            ) {
              let value = null;
              if (signItem.code === "file" || signItem.code === "imageList") {
                value = item[signItem.configKey].map((fileItem) => ({
                  name: fileItem.name,
                  url: fileItem.fileUrl,
                }));
              } else {
                value = item[signItem.configKey];
              }
              obj.customizeConfig.push({
                code: signItem.code,
                name: signItem.value,
                value,
              });
            }
          } else {
            if (signItem.code === "headPhoto") {
              obj[signItem.code] = item[signItem.code].length
                ? item[signItem.code][0].fileUrl
                : "";
            } else if (signItem.code === "subjects") {
              obj.subjectList = item[signItem.code].map((subjectItem) => ({
                levelOne: subjectItem.levelOne,
                levelTwo: subjectItem.levelTwo,
              }));
            } else if (signItem.code === "titles") {
              obj.titleList = item[signItem.code].map((titleItem) => ({
                levelOne: titleItem.levelOne,
                levelOneName: titleItem.levelOneName,
                levelTwo: titleItem.levelTwo || "",
              }));
            } else if (signItem.code === "org") {
              obj.memberOrg = item[signItem.code];
            } else {
              obj[signItem.code] = item[signItem.code];
            }
          }
        });
        return obj;
      });

      // 检测提交参加会议的成员里是否包含已经报名的
      this.$apis.goodsServe.checkMeetingMember(signUpData).then((checkRes) => {
        if (checkRes.resultCode === "200") {
          if (this.skuData.isExamine) {
            // 需要审核，在当前页面提交报名表单，等待审核
            this.$apis.goodsServe
              .meetingMemberSignUp(signUpData)
              .then((res) => {
                if (res.resultCode == 200) {
                  Dialog.alert({
                    message: "提交成功，请等待主办方审核！",
                    theme: "round-button",
                    confirmButtonColor: "#1989fa",
                  }).then(() => {
                    this.$router.go(-1);
                  });
                } else {
                  this.$toast(res.resultDesc);
                }
              });
          } else {
            // 如果是App访问详情页，跳转App确认订单，携带商品数据
            if (this.skuData.fromApp) {
              // 统一APP传递字段
              this.skuData.goodsTitle = this.skuData.meetingTitle;
              this.skuData.skuId = this.skuData.skuId;
              this.skuData.skuPrice = this.skuData.skuPrice;
              var appMeetingData = {
                // 区分图书 1 课程2 会议3
                type: 3,
                // 商品相关信息
                skuData: this.skuData,
                // 针对会议报名表单信息
                meetingMemberList: signUpData.meetingMemberList,
              };
              // isAndroid_ios() true 表示安卓
              if (this.$global.isAndroid_ios()) {
                window.android.confirmOrder(JSON.stringify(appMeetingData));
              } else {
                // JSON.stringify(appMeetingData)
                window.webkit.messageHandlers.confirmOrder.postMessage(
                  JSON.stringify(appMeetingData)
                ); //ios
              }
            } else {
              // 当前会议不需要审核 跳转确认订单页，在确认支付时提交报名人信息
              this.skuData.firstMemberName =
                signUpData.meetingMemberList[0].name;
              sessionStorage.setItem(
                "meetingMemberList",
                JSON.stringify(this.meetingMemberList)
              );
              sessionStorage.setItem(
                "periodicalForm",
                JSON.stringify({
                  periodical: this.periodical,
                  periodicalId: this.periodicalId,
                  inviter: this.inviter,
                  inviterId: this.inviterId,
                })
              );
              sessionStorage.setItem("signUpData", JSON.stringify(signUpData));
              // 跳转确认订单页
              this.$router.push("/meetingConfirmOrder");
            }
          }
        } else {
          this.$toast(checkRes.resultDesc);
        }
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === "meetingDetails" ||
      to.name === "tobepaid" ||
      to.name === "orders"
    ) {
      sessionStorage.removeItem("skuData");
      sessionStorage.removeItem("meetingMemberList");
      sessionStorage.removeItem("periodicalForm");
      sessionStorage.removeItem("signUpData");
      sessionStorage.removeItem("userInvoiceInfo");
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
#fillPaticipantInfo {
  padding: 12px 12px;
  background: #f5f5f5;
  height: 100vh;
  overflow: auto;

  .sign-up-content {
    // 各部分公共样式
    .section-default {
      background: #fff;
      margin-bottom: 12px;
      border-radius: 8px;
      overflow: hidden;

      h1 {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 23px;
        width: 230px;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .meeting-top {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 15px 12px;

      img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 6px;
        margin-right: 10px;
      }

      .meeting-info {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        h1 {
          font-size: 15px;
          font-weight: 500;
          color: #333333;
          line-height: 23px;
          width: 230px;
          flex-shrink: 0;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        p {
          font-size: 13px;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          margin-top: 11px;
          width: 230px;
          flex-shrink: 0;
        }

        .price-count {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 13px;
          font-size: 12px;
          font-weight: 500;
          color: #333333;
          line-height: 17px;

          .symbol {
            font-size: 11px;
          }

          ::v-deep .van-stepper {
            // width: 86px;
            height: 22px;

            border-radius: 10px;
            padding: 0;
            border: 1px solid #cccccc;
            line-height: 20px;
            overflow: hidden;

            .van-stepper__minus,
            .van-stepper__plus {
              height: 20px;
              width: 24px;
              border-radius: 0;
              background: #fff;
              color: #333;
            }

            .van-stepper__minus--disabled {
              color: #dcdcdc;
            }

            .van-stepper__input {
              height: 20px;
              margin: 0;
              width: 38px;
              border-left: 2px solid #ccc;
              border-right: 2px solid #ccc;
              font-size: 14px;
              font-weight: 600;
              color: #333;

              background: #fff;
            }
          }
        }
      }
    }

    .sign-form {
      .sign-form-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
      }
      ::v-deep .van-cell {
        .van-cell {
          padding: 0;
        }
      }
    }
  }
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: #ccc;
}

.sheet-content {
  padding-bottom: 50px;
  .sheet-list {
    max-height: 350px;
    height: 100%;
    overflow-y: auto;
    .sheet-list-item {
      padding: 15px;
      line-height: 22px;
      font-size: 16px;
      text-align: center;
    }
  }
}
</style>
